import { ErrorBoundary } from "react-error-boundary";
import React, { useCallback } from "react";
import type { ReactElement } from "react";

import { featureFlagRequests } from "@/api/(requests)/featureFlagTyped";

import type { FeatureFlag } from "../types";
import { useFeatureFlag } from "../hooks/useFeatureFlag";

type FeatureGateProps = {
  children: ReactElement;
  /**
   * if this value is true and the flagName is not in the feature flag object
   * that contains whether a flag is enabled/disabled the flag is enabled by default.
   */
  defaultFlagValue: boolean;
  /** the component to show if the flag is disabled */
  disabledFallback?: React.ReactElement;
  flagName: FeatureFlag;
};

export function FeatureGate({
  children,
  defaultFlagValue,
  disabledFallback,
  flagName,
}: FeatureGateProps) {
  const { hasLoaded, isEnabled } = useFeatureFlag(flagName);

  const handleError = useCallback(() => {
    const data = { enabled: isEnabled, flag_name: flagName };

    featureFlagRequests.post_feature_flag_error({ context: { showLoader: false }, data });
  }, [isEnabled, flagName]);

  if (!hasLoaded) return <></>;

  const isEnabledLocal = isEnabled || (isEnabled === undefined && defaultFlagValue);

  if (!isEnabledLocal) return disabledFallback ?? <></>;

  return (
    <ErrorBoundary fallback={<></>} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
}
